import { render, staticRenderFns } from "./access-request.vue?vue&type=template&id=54ab475d&scoped=true&"
import script from "./access-request.vue?vue&type=script&lang=ts&"
export * from "./access-request.vue?vue&type=script&lang=ts&"
import style0 from "./access-request.vue?vue&type=style&index=0&id=54ab475d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab475d",
  null
  
)

export default component.exports